import { type CreateRelatedEntityStep } from '../actionSectionTypes';
import { OWNER_SUBTYPES } from './constants';

export const createRelatedEntityRemoveVariable = (
  step: CreateRelatedEntityStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];

  if (
    (step.details.newEntityOwnerSubType === OWNER_SUBTYPES.FROM_VARIABLE &&
      step.details.newEntityOwnerVariable?.value === variableName) ||
    step.details.targetVariable?.value === variableName
  ) {
    if (!nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }
    return {
      nextStep: {
        ...step,
        details: {
          ...step.details,
          targetVariable: step.details.targetVariable
            ? {
                ...step.details.targetVariable,
                deleted: step.details.targetVariable.value === variableName,
              }
            : null,
          newEntityOwnerVariable: step.details.newEntityOwnerVariable
            ? {
                ...step.details.newEntityOwnerVariable,
                deleted:
                  step.details.newEntityOwnerVariable.value === variableName,
              }
            : null,
        },
        hasError: true,
      },
      nextErrorIds,
    };
  }
  return { nextStep: step, nextErrorIds: [] };
};
